export default "__VITE_ASSET__d6890f58__"